import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LandingService } from '../landing.service';

@Component({
  selector: 'app-header-detail-property',
  templateUrl: './header-detail-property.component.html',
  styleUrls: ['./header-detail-property.component.scss']
})
export class HeaderDetailPropertyComponent implements OnInit {
  linkInsta: string;
  linkFace: string;
  linkTik: string;
  linkYou: string;
  domainPage: string;

  constructor(private _LandingService: LandingService, private _router: Router) {
    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
  }

  ngOnInit(): void {
    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
    console.log("este es el dominio", this.domainPage);
    this._LandingService.getServer('getSocialMedia', this.domainPage).then(
      (resp: any) => {
        this.linkFace = resp['facebook'];
        this.linkInsta = resp['instagram'];
        this.linkTik = resp['tikTok'];
        this.linkYou = resp['youTube'];
      }, (err: any) => {
        console.log("ERROR ", err);
      }
    );
  }

  selectedOptionMenu(value: number) {

    switch (value) {
      case 1:
        localStorage.setItem('sectionMenu', '1');
        break;
      case 2:
        localStorage.setItem('sectionMenu', '2');
        break;
      case 3:
        localStorage.setItem('sectionMenu', '3');
        break;
      case 4:
        localStorage.setItem('sectionMenu', '4');
        break;
      case 5:
        localStorage.setItem('sectionMenu', '5');
        break;

    }

    this._router.navigate(['/']);

  }

  redirectSN(typeSN: number): void {
    switch (typeSN) {
      case 1:
        window.open(this.linkFace, '_blank');
        break;
      case 2:
        window.open(this.linkInsta, '_blank');
        break;
      case 3:
        window.open(this.linkYou, '_blank');
        break;
      case 4:
        window.open(this.linkTik, '_blank');
        break;
      case 5:
        this._router.navigate(['/login']);
        break;
    }
  }

}
